export default "__VITE_ASSET__CMjLqkVX__"